// A practice invitation link (/accept-practice-invite?token=...), kept through signing in or creating
// an account like a company invitation (invite.ts). Accepting makes the person a practice member.

const KEY = 'mybooks.practiceInviteToken';
export const PRACTICE_INVITE_PATH = '/accept-practice-invite';
const TOKEN_RE = /^[A-Za-z0-9_-]{32,128}$/;

export function pendingPracticeInviteToken(location: Pick<Location, 'pathname' | 'search'> = window.location): string | null {
  if (location.pathname === PRACTICE_INVITE_PATH) {
    const token = new URLSearchParams(location.search).get('token');
    if (token && TOKEN_RE.test(token)) {
      try { sessionStorage.setItem(KEY, token); } catch { /* storage blocked: the URL still has it */ }
      return token;
    }
  }
  try {
    const kept = sessionStorage.getItem(KEY);
    return kept && TOKEN_RE.test(kept) ? kept : null;
  } catch {
    return null;
  }
}

export function clearPracticeInviteToken() {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
